// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1yPwz","additionalInfo":"AgreementModal_additionalInfo__3KDCF"};